module.exports = __webpack_public_path__ + "omniv2/img/icon-paint.cde0bd74.svg";